import React, { useState, useCallback, useEffect } from 'react';
import t from '~t';
import { normalizeURL } from '~modules/format/url';
import isURL from 'validator/es/lib/isURL';

import {
  Popover,
  Layout,
  Label,
  Text,
  ButtonRow,
  Button,
} from '~ui';
import { Alert } from '~co/overlay/dialog';
import { Preloader } from '~ui'

export default function OverlayLink({ onLink, buttons, ...etc }) {
  const [link, setLink] = useState('');
  const [status, setStatus] = useState('');

  //events
  const onChange = useCallback((e) => setLink(e.target.value), []);
  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      async function now() {
        setStatus('loading');

        let url = link;
        if (!isURL(url, { require_protocol: true }))
          url = normalizeURL(url, { defaultProtocol: 'https:' });

        await onLink(url);
        etc.onClose();
      }

      now().catch((e) => {
        setStatus('error');

        return Alert(`${t.s('saveError')}\n${e.message}`);
      });
    },
    [link, onLink, etc.onClose],
  );

  //on load
  useEffect(() => {
    async function load() {
      //in safari readText works bad, so this line prevents run on safari
      try {
        await navigator.permissions.query({ name: 'clipboard-read' });
      } catch (e) {
        return false;
      }

      let text = '';
      try {
        text = await navigator.clipboard.readText();
      } catch (e) {}

      if (isURL(text, { require_protocol: true })) setLink(text);
    }

    load();
  }, []);

  return (
    <Popover
      className='w-[10rem]'
      closable={status != 'loading'}
      {...etc}
    >
      <form onSubmit={onSubmit}>
        <Layout>
          <Label>URL</Label>

          <Text
            type='url'
            inputMode='url'
            required
            className='field'
            placeholder='https://'
            value={link}
            disabled={status == 'loading'}
            onChange={onChange}
            autoFocus
            selectAll
          />

          <ButtonRow variant='between'>
            {buttons}

            {status == 'loading' ? (
              <Button disabled variant='secondary'>
                <Preloader />
              </Button>
            ) : (
              <Button type='submit' disabled={!link}>
                {t.s('save')}
              </Button>
            )}
          </ButtonRow>
        </Layout>
      </form>
    </Popover>
  );
}
